import { CSSProperties, PropsWithChildren } from 'react'
import styles from './TableGrid.module.css'

interface TableGridProps extends PropsWithChildren {
  days: number
  indent?: string
}

export function TableGrid({
  days,
  indent = '1',
  children,
}: TableGridProps) {
  const hasIndent = +indent > 0
  const baseColumns = `repeat(${days}, 1fr)`
  const style = {
    '--TableGrid-columns': hasIndent
      ? `4rem ${baseColumns}`
      : baseColumns,
    '--TableGrid-columns-sm': hasIndent
      ? `30px ${baseColumns}`
      : baseColumns,
  } as CSSProperties

  return (
    <div className={styles.TableGrid} style={style}>
      {children}
    </div>
  )
}
